import React from 'react';

import {Home} from 'presentation/pages';

export const MakeHomePage: React.FC = () => {
	return <Home />;
};
